import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AuthenticationTokenProvider, RefreshTokenService } from '@symphony-solo/domain/authentication/src';
import { DomainPushNotificationsModule } from '@symphony-solo/domain/push-notifications/src';
import { SharedAppConfigurationModule } from '@symphony-solo/shared/app-configuration/src';
import { CommonCoreModule } from '@symphony-solo/shared/common-core/src';
import { SharedHttpModule } from '@symphony-solo/shared/http/src';
import { SharedTokenInterceptorModule } from '@symphony-solo/shared/token-interceptor/src';
import { AppComponent } from './app.component';
import { HttpProvider } from './services/http-url.provider';
import { PagesSideMenuModule } from '@symphony-solo/pages/side-menu/src/lib/pages-side-menu.module';
@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    SharedHttpModule.forRoot({
      urlProvider: HttpProvider,
    }),
    SharedAppConfigurationModule.forRoot({
      companyGuid: '0F79AC30-5E69-495B-9033-A048E8C6C2BB',
      scanditLicense: 'REPLACE_ME_14_11',
      sharedSecret: '4E4EE679-8026-4377-AE8E-3D6D39752295',
    }),
    DomainPushNotificationsModule.forRoot({
      oneSignalAppId: '8a411aa2-314e-4060-a41a-034da6a4ab54',
      firebaseProjectNumber: '106802923175',
    }),
    CommonCoreModule,
    // todo: find a way to import interceptor in core module
    SharedTokenInterceptorModule.forRoot({
      tokenProvider: AuthenticationTokenProvider,
      refreshTokenProvider: RefreshTokenService,
    }),
    PagesSideMenuModule
  ],
  providers: [StatusBar, SplashScreen, { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {}
